import { useForm } from "react-hook-form";
import type { SignUpData } from "types/auth";
import "styles/cadastro.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type Address = {
  rua: string;
  numero: string;
  complemento?: string;
  cidade: string;
  estado: string;
  cep: string;
  pais: string;
};

type FormData = {
  codigoDeEndereco?: string;
  enderecoEmpresa: Address;
};

type Props = {
  data: SignUpData;
  onNext: (p: Partial<SignUpData>) => void;
  onBack: () => void;
};

export default function StepAddress({ data, onNext, onBack }: Props) {
  const { t } = useTranslation();
  const { register, handleSubmit } = useForm<FormData>({
    defaultValues: {
      codigoDeEndereco: data.codigoDeEndereco ?? "",
      enderecoEmpresa: {
        pais: data.enderecoEmpresa?.pais ?? "BR",
        estado: data.enderecoEmpresa?.estado ?? "",
        cidade: data.enderecoEmpresa?.cidade ?? "",
        cep: data.enderecoEmpresa?.cep ?? "",
        rua: data.enderecoEmpresa?.rua ?? "",
        numero: data.enderecoEmpresa?.numero ?? "",
        complemento: data.enderecoEmpresa?.complemento ?? "",
      },
    },
  });

  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const onSubmit = async (values: FormData) => {
    setLoading(true);
    setErro(null);
    onNext(values);
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="cadastro-grid-campos">
        <div className="cadastro-campo">
          <label htmlFor="pais" className="cadastro-rotulo">{t("fields.country")}</label>
          <input id="pais" className="cadastro-entrada" autoComplete="country-name" required
            {...register("enderecoEmpresa.pais")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="estado" className="cadastro-rotulo">{t("fields.state")}</label>
          <input id="estado" className="cadastro-entrada" required
            {...register("enderecoEmpresa.estado")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="cidade" className="cadastro-rotulo">{t("fields.city")}</label>
          <input id="cidade" className="cadastro-entrada" required
            {...register("enderecoEmpresa.cidade")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="cep" className="cadastro-rotulo">{t("fields.zip")}</label>
          <input id="cep" className="cadastro-entrada" required inputMode="numeric" maxLength={9}
            {...register("enderecoEmpresa.cep")} />
        </div>

        <div className="cadastro-campo col-span-2">
          <label htmlFor="rua" className="cadastro-rotulo">{t("fields.street")}</label>
          <input id="rua" className="cadastro-entrada" required
            {...register("enderecoEmpresa.rua")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="numero" className="cadastro-rotulo">{t("fields.number")}</label>
          <input id="numero" className="cadastro-entrada" required
            {...register("enderecoEmpresa.numero")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="complemento" className="cadastro-rotulo">{t("fields.complement")}</label>
          <input id="complemento" className="cadastro-entrada"
            {...register("enderecoEmpresa.complemento")} />
        </div>
      </div>

      {erro && <div className="cadastro-erro">{erro}</div>}

      <div className="cadastro-acoes">
        <button type="button" className="cadastro-btn-ghost" onClick={onBack} disabled={loading}>
          {t("buttons.back")}
        </button>
        <button type="submit" className="cadastro-btn-primario" disabled={loading}>
          {t("buttons.continue")}
        </button>
      </div>
    </form>
  );
}
